<template>
  <div>
    <div v-if="!alreadyReset">
      <h1>{{ $t("passwordForgotten.title") }}</h1>
      {{ $t("passwordForgotten.content") }}
      <v-form lazy-validation ref="form" v-model="isValid" @submit.prevent="passwordReset">
        <v-text-field :rules="[rules.required, rules.email]" label="Email" v-model="email"></v-text-field>
      </v-form>
      <v-btn :disabled="!isValid" @click="passwordReset" color="success">{{ $t("global.send") }}</v-btn>
    </div>
    <div v-if="alreadyReset">
      <h1>{{ $t("passwordForgotten.alreadyResetTitle") }}</h1>
      {{ $t("passwordForgotten.alreadyResetContent") }}
      <v-btn color="primary" to="/login">{{ $t("passwordForgotten.goBackToLogin") }}</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "PasswordForgottenView",
  data: () => ({
    email: "",
    alreadyReset: false,
    isValid: true
  }),
  computed: {
    rules() {
      return {
        required: value => !!value || this.$t("global.error.required"),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("global.error.email");
        }
      };
    }
  },
  methods: {
    passwordReset() {
      if (this.$refs.form.validate()) {
        let result = this.$store.dispatch("confirmDialog", {
          content: this.$t("passwordForgotten.beforeResetConfirm.content"),
          title: this.$t("passwordForgotten.beforeResetConfirm.title")
        });
        result.then(() => {
          this.axios
            .post("settings/my-profile/password-forgotten", {
              email: this.email
            })
            .then(() => {
              this.alreadyReset = true;
            });
        });
      }
    }
  }
};
</script>

<style scoped></style>
